import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals';
import { initFonts } from './services/fontService';
import { errorCaptureService } from './services/errorCaptureService';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import theme from './theme'; // your custom MUI theme
import { ThemeProvider } from './components/theme/ThemeProvider';
import { AuthProvider } from './components/auth/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { AppDataProvider } from './contexts/AppDataContext';
import { UserSubscriptionProvider } from './contexts/UserSubscriptionContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { clearStorage } from './utils/localStorageManager.js';

// Handle logout parameter synchronously BEFORE React renders.
// This must happen here because the React Router <Navigate to="/upload" replace />
// strips query params before any useEffect can read them.
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('logout') === 'true') {
    clearStorage();
    window.location.replace('/upload');
}

// Initialize error capture service before anything else
errorCaptureService.initialize();

initFonts();

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem={false}
      storageKey="naptune-theme"
      disableTransitionOnChange={false}
    >
      <MUIThemeProvider theme={theme}>
        <AuthProvider>
          <UserSubscriptionProvider>
            <PermissionProvider>
              <AppDataProvider>
                <App />
              </AppDataProvider>
            </PermissionProvider>
          </UserSubscriptionProvider>
        </AuthProvider>
      </MUIThemeProvider>
    </ThemeProvider>
  </GoogleOAuthProvider>
);

reportWebVitals();
